import React from "react";
import styles from "./styles.module.scss";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { authService } from "../../../../../../services/AuthService";
import { InputPassword } from "../../../../../../boxes/InputPassword/InputPassword";

export function SecurityQuestion({ answer, setAnswer, isDisabled }) {
  const { tAuth: t } = useAppTranslation.Auth({
    keyPrefix: "twoFactor.alternativeOtp",
  });

  const question = authService.getPreLoginData().securityQuestion;

  return (
    <div className={styles.root}>
      <div>{t("answerTitle")}</div>
      <b className={styles.question}>{question}</b>
      <div>
        <InputPassword
          placeholder={t("answerPlaceholder")}
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          isDisabled={isDisabled}
        />
        <span className={styles.note}>{t("answerNote")}</span>
      </div>
    </div>
  );
}
